module.exports = __webpack_public_path__ + "static/media/delete.8173d001.svg";